<template>
    <div class="toPay-m">
        <div class="toPay-m-l">
            <div class="toPay-m-txt selectBookingCount">{{totalCount}}</div>
            <div class="toPay-m-txt">张订单</div>
            <div class="toPay-m-txt vertical-bar">|</div>
            <div class="toPay-m-txt">应付总计:￥</div>
            <div class="toPay-m-price">{{totalAmount}}</div>
        </div>
        <div v-if="!allowUseTikTokCode" class="toPay-m-r" @click="goToPay">立即支付</div>
        <div v-else class="toPay-m-r disable">立即支付</div>
    </div>
</template>

<script>
import bookingStatusHelper from '@/utilities/bookingStatusHelper'
export default {
    name: "BookingListBottom",
    props: {
        selectedBooking: {
            type: Array
        },
        selectedOpenBooking: {
            type: Array
        }
    },
    data() {
      return {
        allowUseTikTokCode: false
      }
    },
    watch: {
      selectedBooking(val) {
        let count = 0;
        val && val.forEach((row)=> {
          if(row.tikTokCouponStatus === 1 || row.tikTokCouponStatus === 3) {
            count++;
          }
        });
        this.allowUseTikTokCode = count > 0;
      }
    },
    methods: {
        getTotalAmountByBookings (bookings) {
            let amount = 0
            bookings.forEach((booking) => {
                const status = bookingStatusHelper.getBookingStatus(booking)
                if (status == 'unpaid') {
                    amount += booking.amount
                } else if (status == 'unpaidFull'){
                    amount += booking.balanceDue
                }
            })
            return amount
        },
        goToPay () {
            if (this.selectedBooking.length > 0) {
                this.$router.push({
                    name: "Pay",
                    query: {
                        // 使用加密的的字段encBookingId
                        bookingId: this.selectedBooking.map(r=>r.encBookingId).join(',')
                    }
                })
            } else if (this.selectedOpenBooking.length > 0) {
                this.$router.push({
                    name: "OpenBookingPay",
                    query: {
                        orderId: this.selectedOpenBooking[0].openBookingOrderId
                    }
                })
            }
        }
    },
    computed: {
        totalAmount () {
            if (this.selectedBooking.length > 0) {
                return this.getTotalAmountByBookings(this.selectedBooking)
            } else if (this.selectedOpenBooking.length > 0) {
                return this.getTotalAmountByBookings(this.selectedOpenBooking)
            }
            return 0
        },
        totalCount () {
            if (this.selectedBooking.length > 0) {
                return this.selectedBooking.length
            } else if (this.selectedOpenBooking.length > 0) {
                return this.selectedOpenBooking.length
            }
            return 0
        }
    }
}
</script>

<style lang="less" scoped>
.toPay-m {
    position: fixed;
    left: 0;
    bottom: 0;
    z-index: 10100;
    display: -webkit-box;
    display: -webkit-flex;
    display: -moz-box;
    display: -ms-flexbox;
    display: flex;
    width: 100%;
    height: 49px;
    .toPay-m-l {
        -webkit-box-flex: 0;
        -webkit-flex: none;
        -moz-box-flex: 0;
        -ms-flex: none;
        flex: none;
        display: -webkit-box;
        display: -webkit-flex;
        display: -moz-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
        -webkit-align-items: center;
        -moz-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        width: 253px;
        padding: 0 20px;
        background-color: #4A90E2;
        color: #fff;
        .toPay-m-txt {
            font-size: 14px;
            line-height: 16px;
        }
        .selectBookingCount {
            padding-right: 2px;
        }
        .toPay-m-txt {
            font-size: 14px;
            line-height: 16px;
        }
        .vertical-bar {
            padding: 0 10px;
            position: relative;
            top: -2px;
        }
        .toPay-m-price {
            font-size: 18px;
            line-height: 21px;
            font-weight: bold;
            padding-left: 2px;
        }
        &.is-full {
          width: 100%;
        }
    }
    .toPay-m-r {
        -webkit-box-flex: 1;
        -webkit-flex: 1;
        -moz-box-flex: 1;
        -ms-flex: 1;
        flex: 1;
        display: -webkit-box;
        display: -webkit-flex;
        display: -moz-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-pack: center;
        -webkit-justify-content: center;
        -moz-box-pack: center;
        -ms-flex-pack: center;
        justify-content: center;
        -webkit-box-align: center;
        -webkit-align-items: center;
        -moz-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        font-size: 14px;
        line-height: 1;
        color: #454545;
        letter-spacing: 1px;
        font-weight: bold;
        background: -webkit-gradient(linear, left top, right top, from(#FEBC10), to(#FAD961));
        background: -webkit-linear-gradient(left, #FEBC10, #FAD961);
        background: -moz-linear-gradient(left, #FEBC10, #FAD961);
        background: -o-linear-gradient(left, #FEBC10, #FAD961);
        background: linear-gradient(to right, #FEBC10, #FAD961);
        &.disable {
          background: #D2D9DE;
        }
    }
}
</style>
